
import { Vue, Component } from "vue-property-decorator";

@Component({ name: "icon-video" })
export default class IconVideo extends Vue {
  sData: string = require("@icon/feather/video.svg");
}
